//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import request from "../components/request";
  export default {
    props:['loginSuc','path','canChangCurrency'],
    data() {
      return {
        modal3: false,
        userName: "",
        emailorPhone: "",
        email: "",
        jsonstr: "",
        str: "",
        isActive: 1,
        showname: false,
        lang: [],
        curreyStr:"EUR$",//默认欧元
      }
    },
    watch:{
      loginSuc(newVal,oldVal){
        if(newVal == 'true'){
          this.showname = 'true'
          var str = request.getCookie();
          this.jsonstr = JSON.parse(str);
        }
      }
    },
    created() {
      this.lang = this.$i18n.locale;

      if (this.lang && this.lang == "en") {
        this.lang = "en_US";

      } else if (this.lang == "zhCHS") {

        this.lang = "zh_CN";
      } else {
        this.lang = "zh_TW"
      }

      var cookie = document.cookie
      if(cookie.indexOf('curCurrency')>-1){
        var curCurrency = cookie.split('curCurrency=')[1].split(';')[0]

        if (curCurrency === '1') {
          this.curreyStr = 'USD$'
        }

        if (curCurrency === '4') {
          this.curreyStr = 'EUR€'
        }

        if (curCurrency === '0') {
          this.curreyStr = 'CNY￥'
        }
      }

      this.str = request.getCookie();
      if(this.str){
        this.jsonstr = JSON.parse(this.str);
      }

      if (!this.str) {
        // console.log('没值')
        this.showname = false;
      } else {
        this.email = this.str.match(/email(\S*)com/);

        this.showname = true;
      }
    },
    //清除所有cookie函数
    methods: {
      // 币种切换
      currencyChange(data) {
        if (data === '1') {
          this.curreyStr = 'USD$'
        }

        if (data === '4') {
          this.curreyStr = 'EUR€'
        }

        if (data === '0') {
          this.curreyStr = 'CNY￥'
        }
        this.$emit('currencyChangeApp', data);
        window.document.cookie = 'curCurrency=' + data;
      },
      //点击注销登录按钮
      showLogoutModel(){
        this.modal3 = true;
      },

      //取消
      returnFalse(){
        return false;
      },

      // 确定注销登录
      okLogout() {
        request.post(`/user/logout`, {
          userId: this.jsonstr.useId,
          language: this.lang,
        }).then(
          function (response) {
            if(response.data){
              if (response.data.code == 200) {
                request.setCookie("", "", "", "", "", "", "", "", "", "", -1000);
                setTimeout(() => {
                  //this.$Modal.remove();
                  window.location.reload()
                  this.$router.push({path: "/"});
                }, 1000);
              }
              if (response.data.code !== 200) {
                this.$Modal.error({
                  content: this.$t('message.accountNotExist')
                });
              }
            }
          }.bind(this)
        )
      },

      changeLocale(locale) {
        this.$emit('changeAppLocale', locale);
        window.document.cookie = 'lang=' + locale;
        // this.$router.go(0)
        // this.$router.replace(0)
        // window.location.reload()
      },
      // 点击tabs
      home_tabs_option1(tab) {
        this.isActive = 1;
        this.currentTab = tab;
      },
      home_tabs_option2(tab) {
        this.isActive = 2;
        this.currentTab = tab;
      },
      home_tabs_option3(tab) {
        this.isActive = 3;
        this.currentTab = tab;
      }
    },
  }



// WEBPACK FOOTER //
// ./src/components/NavBar.vue